var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPhotoFrame = function SvgPhotoFrame(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "268px",
    height: "164px",
    viewBox: "0 0 268 164",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "photo_frame")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "current",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo_frame",
    transform: "translate(2.000000, 2.000000)",
    stroke: "current",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 42 0 0 42 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy",
    transform: "translate(243.000000, 21.000000) scale(-1, 1) translate(-243.000000, -21.000000) ",
    points: "222 42 222 0 264 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    transform: "translate(21.000000, 139.000000) scale(1, -1) translate(-21.000000, -139.000000) ",
    points: "0 160 0 118 42 118"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy",
    transform: "translate(243.000000, 139.000000) scale(-1, -1) translate(-243.000000, -139.000000) ",
    points: "222 160 222 118 264 118"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotoFrame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo_frame.1e199310.svg";
export { ForwardRef as ReactComponent };